import React from 'react';
const SvgTranslate = props => (
  <svg xmlns="http://www.w3.org/2000/svg" version="1.1" {...props}>
    <path
      strokeWidth="0"
      className="cls-1"
      d="M126,240h24.1l-54.6-155.2h-26L14.9,240h23.2l14.5-44.7h59.1l14.4,44.7ZM59.1,175.3l6.8-20.9c5.7-17.1,10.8-34.2,15.7-52h1c5.1,17.7,10.2,34.9,15.9,52l6.7,20.9h-46.1Z"
    />
    <path
      strokeWidth="0"
      className="cls-1"
      d="M369.6,193.1v-20h-63v-20.9h-20v20.9h-63v20h26.4c2.7,13.5,10.3,39.3,32,64.1-14.1,12-32.8,22.9-57.7,30.6l5.9,19.1c28.7-8.8,50.1-21.5,66.2-35.5,16.1,14,37.5,26.7,66.2,35.5l5.9-19.1c-25-7.6-43.7-18.6-57.7-30.6,21.7-24.8,29.3-50.7,32-64.1h27ZM296.3,243c-16.3-19-23-38.3-25.8-49.9h51.6c-2.8,11.6-9.5,30.9-25.8,49.9Z"
    />
    <rect
      strokeWidth="0"
      className="cls-1"
      x="35.5"
      y="185"
      width="315.9"
      height="18"
      transform="translate(-71.3 264.5) rotate(-60)"
    />
  </svg>
);
export default SvgTranslate;
